import { render } from "./GlobalSaveIndicator.vue?vue&type=template&id=4fccc056&scoped=true"
import script from "./GlobalSaveIndicator.vue?vue&type=script&lang=js"
export * from "./GlobalSaveIndicator.vue?vue&type=script&lang=js"

import "./GlobalSaveIndicator.vue?vue&type=style&index=0&id=4fccc056&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fccc056"]])

export default __exports__